import {useGetAktivePlassSaker} from "../../api/plassSaker";
import {usePrissoknader} from "../../api/prissoknader";
import React, {ReactNode} from "react";
import {sorterAktuelleSakerPåDato, SakInfo} from "../../utils/sakService";
import {
  OPPSIGELSE_ROUTE,
  PERMISJON_ROUTE,
  PLASS_ENDRE_ROUTE,
  PLASS_TILBUD_ROUTE,
  PRIS_SØKNAD_ROUTE
} from "../../routes";
import {Link} from "react-router-dom";
import {PktAlert, PktTable, PktTableBody, PktTableDataCell, PktTableRow} from "@oslokommune/punkt-react";
import { isLoadingStatus} from "../../utils/utils";
import LoadingSpinner from "../LoadingSpinner";

export function AktuelleSaker() {
  const [aktivePlassSaker, aktivePlassSakerResponseStatus] = useGetAktivePlassSaker()
  const [prissøknader, prissøknaderResponseStatus] = usePrissoknader()
  if (isLoadingStatus(aktivePlassSakerResponseStatus) || isLoadingStatus(prissøknaderResponseStatus)) {
    return (
      <SectionWrapper>
        <LoadingSpinner/>
      </SectionWrapper>
    )
  }
  if (aktivePlassSakerResponseStatus === "error" || prissøknaderResponseStatus === "error" ||
    aktivePlassSaker === undefined || prissøknader === undefined) {
    return (
      <SectionWrapper>
        <PktAlert skin={"warning"}>
          Det skjedde en feil ved innhenting av dine aktive saker.
        </PktAlert>
      </SectionWrapper>
    )
  }

  const aktuelleSaker = sorterAktuelleSakerPåDato(aktivePlassSaker, prissøknader);

  return (
    <SectionWrapper>
      {aktuelleSaker.length > 0 ? (
          <PktTable responsiveView skin={'zebra-blue'} className={'mt-size-20'}>
            <PktTableBody>
              {aktuelleSaker.map((sak) => (
                <PktTableRow key={sak.id}>
                  <PktTableDataCell dataLabel={'Dato'}>
                    <span className={'pkt-sr-only'}>Dato, </span>
                    {new Date(sak.dato).toLocaleDateString('no')}
                  </PktTableDataCell>
                  <PktTableDataCell dataLabel={'Sak'}>{getSakLink(sak)}</PktTableDataCell>
                </PktTableRow>
              ))}
            </PktTableBody>
          </PktTable>
        ) :
        (
          <div>
              <i> Du har ingen pågående saker hos oss for øyeblikket. </i>
          </div>
        )}
    </SectionWrapper>
  )
}

const SectionWrapper = ({children}: { children: ReactNode }) => (
  <section>
    <h2 className={'pkt-txt-22 mt-size-40 mb-size-20'}>Aktive saker</h2>
    {children}
  </section>
)

function getSakLink(sak: SakInfo): React.ReactNode {
  switch (sak.type) {
    case 'PLASS_SØKNAD':
      return (
        <a href={`${PLASS_ENDRE_ROUTE}/${sak.id}`} className={'pkt-txt-16'}>
          Søknad om barnehageplass for {sak.navn}{' '}
        </a>
      )
    case 'PLASS_TILBUD':
      return (
        <a href={`${PLASS_TILBUD_ROUTE}/${sak.id}`} className={'pkt-txt-16'}>
          Tilbud om barnehageplass for {sak.navn}{' '}
        </a>
      )
    case 'PRIS_SOKNAD':
      return (
        <Link className={'pkt-txt-16'} to={`${PRIS_SØKNAD_ROUTE}/${sak.id}`}>
          Søknad om redusert barnehagepris
        </Link>
      )
    case 'PLASS_OPPSIGELSE':
      return (
        <Link className={'pkt-txt-16'} to={`${OPPSIGELSE_ROUTE}/${sak.id}`}>
          Oppsigelse av plass for {sak.navn}
        </Link>
      )
    case 'PLASS_PERMISJONSSØKNAD':
      return (
        <Link className={'pkt-txt-16'} to={`${PERMISJON_ROUTE}/${sak.id}`}>
          Søknad om permisjon for {sak.navn}
        </Link>
      )
    default:
      return ''
  }
}
